import React from "react";
import ReactDOM from "react-dom/client";
import "@fortawesome/fontawesome-svg-core/styles.css";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import { applyThemeColor, buildTheme, useResolvedTheme } from "./theme";
import { initSSE } from "./shared/sse/connection";

// Start SSE once at app boot — persists across all renders, never reconnected by React.
initSSE();

function Root() {
  const mode = useResolvedTheme();
  const theme = React.useMemo(() => buildTheme(mode), [mode]);
  // The browser chrome follows the shell surface, not a fixed accent (spec §8).
  React.useEffect(() => applyThemeColor(mode), [mode]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
